import {createFileRoute} from '@tanstack/react-router';
import LeaguesView from '../../../../leagues/LeaguesView.tsx';

export const Route = createFileRoute('/_app/volleyball/leagues/$league_uid/game/$game_uid')({
    component: RouteComponent,
})

function RouteComponent() {
    return <LeaguesView />
}
